module.exports = __webpack_public_path__ + "assets/images/avatar_256x256.png";


//////////////////
// WEBPACK FOOTER
// ./app/common/header/images/avatar_256x256.png
// module id = dgJw
// module chunks = 1